<template>
<div class="vx-row">
  <div class="vx-col w-full  mb-base">
                <vx-card>
                     <div slot="no-body">
                        <img src="../assets/images/kebap-background-2.jpg" alt="content-img" class="responsive card-img-top">
                    </div>
                      <div class="my-6">
                        <h5 class="mb-2">Kontakt</h5>
                        <p class="text-grey">Du hast Fragen an uns?</p>
                    </div>
                    <vs-input label-placeholder="Dein Name" class="w-full mb-6" v-model="name" />
                    <vs-input label-placeholder="Deine E-Mail" type="email" class="w-full mb-6" v-model="email" />
                    <vs-textarea label="Dein Anliegen" v-model="msg" />
                    <vs-button :disabled="!validateForm" class="mr-4" @click="onSend">Senden</vs-button>
                    <vs-button type="border" color="warning" @click="name = email = msg =''" class="mt-3">Abbrechen</vs-button>
                </vx-card>
            </div>
</div>
</template>

<script>
import axios from "../axios";

export default {
    data() {
        return {
        name:"",
        email:"",
        msg: ""
        }
    },
    computed: {
        validateForm() {
            if (this.name !=="" && this.email !== "" && this.msg !== "") {
                return true;
            } else {
                return false;
            }
        }
    },
    methods: {
        async onSend() {
            try {
            const body = {
                name: this.name,
                email: this.email,
                msg: this.msg,
            }
            await axios.post("/api/contact", body);
            this.name = this.email = this.msg = "";
            this.$vs.notify({
            title: "Dankeschön!!",
            text: "Vielen Dank für deine Nachricht. Wir werden so schnell es geht auf dich zukommen",
            color: "success",
            position: "top-center",
            icon: "favorite",
          });
            } catch(error) {
                console.log(error);
                  this.$vs.notify({
            title: "Fehler -.-",
            text: "Leider ist ein Fehler aufgetreten. Versuche es später noch einmal.",
            color: "danger",
            position: "top-center",
            icon: "error",
          });
            }
        }
    }
}
</script>

<style lang="scss" scoped>
img {
    max-height: 40vh;
    object-fit: cover;
    background-repeat: no-repeat;
}
</style>